export default __webpack_public_path__ + "static/media/7.f33ea946.PNG";